import { SessionStorageService } from './../../storage/sessionStorage.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { map,filter, pluck  } from 'rxjs/operators';
import { FiltrosSolicitudDes } from 'app/models/FiltrosSolicitudDes';
import { Observable } from "rxjs";
import { LocalService } from '../../storage/localService';

@Injectable({ providedIn: 'root' })

export class SolicitudDesembolsoService {
  header: HttpHeaders;
  dataSolicitudD : any;
  message: Observable<any>;
  idEmpresa_Factor : any;
  readonly urlBase =  environment.rutaBase;
  
  constructor(private http : HttpClient, private accesoService :AccesoService,private sessionStorageService: SessionStorageService,private localService : LocalService){
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage()
  }

  datoStorage(){
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
   this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
   if (this.idEmpresa_Factor == undefined) {
    this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
   } 
  }

  FiltroListadoSoliDes(Filtros: FiltrosSolicitudDes,fechaD:any, fechaH:any){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/SolicitudDesembolso?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&idSolicitudDesembolso=${Filtros.IdSolicitudDesembolso}&IdAdquirente=${Filtros.IdAd}&IdProveedor=${Filtros.IdProv}&Estado=${Filtros.Estado}&Moneda=${Filtros.Moneda}&FechaInicial=${fechaD}&FechaFinal=${fechaH}`,{headers});
  }

  //Obtiene Solicitud Desembolso Por ID
  ObtenerDesembolsoPorId(idSolicitudDesembolso: number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/SolicitudDesembolsoPorId?idEmpresa_Factor=${this.idEmpresa_Factor}&idSolicitudDesembolso=${idSolicitudDesembolso}`,{headers});
  }

  //Crea Solicitud Desembolso
  crearSoliDes(body:any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/SolicitudDesembolso?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  //Anula una Solicitud Desembolso
  anularSolicitudDesembolso(body:any){
    let headers = this.header;
    return this.http.put(`${this.urlBase}/AnularSolicitudDesembolso?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  //Aprueba Solicitud Desembolso
  altaSolicitudDesembolso(body : string){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/AltaSolicitudDesembolso?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers}).pipe( map ( (data) => {return data;}))
  }

  //Actualiza estado de la solicitud desembolso en Listado Desembolso
  actualizarSoliDes(body:any,idSolicitudDesembolso? :any){
    let headers = this.header;
    return this.http.put(`${this.urlBase}/SolicitudDesembolsoEstado?idEmpresa_Factor=${this.idEmpresa_Factor}&idSolicitudDesembolso=${idSolicitudDesembolso}`,body,{headers});
  }

  //Lista las Solicitudes de Desembolso Pendientes y Firmadas
  obtenerSolicitudDesembolsoPendientes(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/SolicitudDesembolsoPendientes?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  //Herramiento de Fernando
  ObtenerTotalImporteSunat(idSolicitudDesembolso: number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/TotalImporteSunat?idEmpresa_Factor=${this.idEmpresa_Factor}&idSolicitudDesembolso=${idSolicitudDesembolso}`,{headers});
  }
    
}